import { SET_CURRENT_ORG, UIStatePayload, SET_BASIC_NLP_TAB } from "./types";

const initialState: {
  selectedBasicNLPTab: "schema" | "data"
  [key: string]: any
} = {
    selectedBasicNLPTab:  "schema"
};

export function uiStateReducer(state = initialState, action: UIStatePayload) {
  switch (action.type) {
    case SET_CURRENT_ORG:
      // Saves the last used org (mapped to the user) in the UI state
      return {
        ...state,
        selectedOrg: { [action.data.userId]: action.data.selectedOrg.id },
      };
    case SET_BASIC_NLP_TAB:
      return {
        ...state,
        selectedBasicNLPTab: action.data
      };
    default:
      return state;
  }
}
